import * as XLSX from 'xlsx';
import { buildFunnelExportRows } from './group-agents-by-agency';
export function downloadFunnelAgentsExcel(agents, filename = 'voronka-agentov.xlsx', options = {}) {
    const includeProfileCompleteness = options.includeProfileCompleteness === true;
    const includeSocialCompleteness = options.includeSocialCompleteness === true;
    const includeSmartisCaptured = options.includeSmartisCaptured === true;
    const includeTgBotAvailable = options.includeTgBotAvailable === true;
    const includeUnitySources = options.includeUnitySources === true;
    const rows = buildFunnelExportRows(agents, {
        includeProfileCompleteness,
        includeSocialCompleteness,
        includeSmartisCaptured,
        includeTgBotAvailable,
        includeUnitySources,
    });
    const sheetRows = rows.map((row) => {
        const out = {
            ФИО: row.displayName,
            'Bitrix ID': row.bitrixId,
            'Agent ID': row.agentId,
            Телефон: row.phone,
            АН: row.agencyName,
        };
        if (includeProfileCompleteness) {
            out['Заполненность анкеты, %'] = row.profileCompleteness ?? '';
        }
        if (includeSocialCompleteness) {
            out['Заполненность соцсетей, %'] = row.socialCompleteness ?? '';
            out['Соцсети'] = row.socialNetworks ?? '';
        }
        if (includeSmartisCaptured) {
            out['Захвачен'] = row.smartisCaptured ?? '';
        }
        if (includeTgBotAvailable) {
            out['Доступен в ТГ'] = row.tgBotAvailable ?? '';
        }
        if (includeUnitySources) {
            out['Источники ЮНИТИ, %'] = row.unitySourcesPercent ?? '';
        }
        return out;
    });
    const worksheet = XLSX.utils.json_to_sheet(sheetRows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Агенты');
    XLSX.writeFile(workbook, filename);
}
